import React from 'react'

import { user } from '../../core/controllers/user';
import ReportsTableGenerator from '../../components/Reports/ReportsTableGenerator';

export default class ReportsTemplate extends React.Component {
    constructor(props) {
        super(props);
    }

    render(){
        return (
            <div>
                <ReportsTableGenerator  />
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/views/Reports/Reports.jsx